<!-- Совмещает цену заказа и статус оплаты в компактной табличной ячейке. -->
<template>
  <div class="order-price-payment-cell">
    <strong>{{ formattedPrice }}</strong>
    <BaseStatusSelect
      compact
      :value="value?.payment_status"
      :label="statusLabel"
      :color="statusColor"
      :options="statusOptions"
      @change="$emit('payment-status-change', $event)"
    />
  </div>
</template>

<script>
import { formatBigNumber } from "@/utils/numberUtils";

export default {
  name: "OrderPricePaymentCell",

  emits: ["payment-status-change"],

  props: {
    value: { type: Object, default: null },
    statusColor: { type: String, default: "#64748b" },
    statusOptions: { type: Array, default: () => [] },
  },

  computed: {
    statusLabel() {
      const status = this.statusOptions.find(
        (option) => option.value === this.value?.payment_status
      );
      return status?.label || this.value?.payment_status_name || "Статус не указан";
    },
    formattedPrice() {
      const price = this.value?.price;
      if (price === null || price === undefined || price === "") return "—";
      return `${formatBigNumber(price)} ₽`;
    },
  },
};
</script>

<style scoped>
.order-price-payment-cell {
  display: flex;
  min-width: 120px;
  align-items: flex-end;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
  text-align: right;
}

.order-price-payment-cell > strong {
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
</style>
